import { InspectParams } from "interface/interface.inspect";
import axiosInstance from "plugin/axios";

interface SimpleTestResultRequest {
  score: number;
  twoFiveScore: number;
  sixSevenScore: number;
  type: number;
}

export const fetchSaveSimpleTestResult = async (
  data: SimpleTestResultRequest
) => {
  try {
    const response = await axiosInstance.post(`/test-result/simple`, data);
    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const fetchLoadSimpleTestResult = async (params: InspectParams) => {
  try {
    const response = await axiosInstance.get(`/test-result/simple`, { params });
    return response.data;
  } catch (error) {
    throw new Error();
  }
};
